import { Helmet } from "react-helmet-async";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_auto-solutions-stage/artifacts/1glpuwnd_Photoroom_20260515_125444.png";
const SITE = "ValueDrive Auto Solutions";

const Seo = ({ title, description, path = "", image = LOGO_URL }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Tyres, Mobile Fitting & Roadside Help in Middlesbrough`;
  const desc = description || "Buy premium tyres online with free UK delivery, professional mobile fitting and 24/7 roadside assistance across Middlesbrough & Teesside.";
  const url = `https://valuedriveauto.co.uk${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
